import React, { useEffect, useState } from "react"; 

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { getCountries } from "../../../../../MyApi/sb/countries";


import LoadingSpinner from "../../../../UI/spinner";
import SingleCountry from "../singleCountry";
import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";
import PagnationComponent from "../../../../UI/pagnationComponent";

import classes from "../../../../../assets/css/globalDataTable.module.css";

const CountriesDataTable = () => {
const [filerText,setFilterText]= useState("")
const [currentPage, setCurrentPage] = useState(1);
const {t ,i18n} = useTranslation()
const lang = i18n.language
const {data , isLoading ,refetch ,error} = useQuery(["getCountries",lang] ,()=>getCountries(lang))


useEffect(()=>{
refetch()
},[filerText,refetch])

const countries = data?.data|| []
const responeMessage = data?.message
const totalPages =data?.total
if(isLoading){
    return <LoadingSpinner/>
}
if(error){  
  return <ErrorMessage error={error}/>
}
if(countries.length === 0){
  return<NoData responeMessage={responeMessage}/>
}



if(!data){
    return <div>no data available</div>
}



  return (
    <div className="container-fluid"> 
      <div className="card">
        <div className="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
            <thead className={classes.tableHeader}>    
            <th>#</th> 
            <th>{t("Name")}</th>  
            <th>{t("Phone-code")}</th>  
            <th>{t("Currency")}</th>  
            <th>{t("Symbol")}</th>
            <th>{t("Actions")}</th>
            </thead>
          <tbody>
          {countries.map((country )=> ( <SingleCountry key={country.id}  country={country}  classes={classes}  refetch={refetch} lang={lang}/> ))   }
          </tbody>
        </table> 
        </div>
        
      </div>
      <div className="d-flex justify-content-center">
           <PagnationComponent    
           currentPage={currentPage}
           setCurrentPage={setCurrentPage}
           totalItems={totalPages}/>
        </div>   
    </div>
  );
};

export default CountriesDataTable;
